export default __webpack_public_path__ + "static/media/page-2.37977fea.png";